import {register} from 'dna-react-ioc'
import {interfaces} from 'inversify'
import {
    IFilterContainerStore,
    TRangePickerContainerStore,
    TSelectContainerStore
} from '~/code/components'
import {Currencies} from '~/code/constants'
import {DEFAULT_CURRENCY, getPortalCurrencies} from '@/constants/currencies'
import {IDccStore} from '~/code/pages/DCC'
import {
    DccFilterStoreSymbol,
    DccTableFilterCurrencySelectContainerStoreSymbol,
    DccTableFilterRangePickerContainerStoreSymbol,
    DccTableFilterStoreSymbol,
    IDccTableFilterStore
} from '~/code/pages/DCC/components/DccTableFilter'
import {DccStoreSymbol} from '~/code/pages/DCC/DCC'
import {PeriodType, RangePickerStore, SelectContainerStore} from '~/code/stores'
import {DccFilterStore} from '~/code/stores/dcc/DccFilterStore'
import {DccTableFilterStore} from '~/code/stores/dcc/DccTableFilterStore/DccTableFilterStore'
import {DccStore} from '~/code/stores/dcc/DccStore'

export const dccState = () => {
    register<IDccStore>(DccStoreSymbol).to(DccStore).inSingletonScope()

    // filter stores
    register<IFilterContainerStore>(DccFilterStoreSymbol)
        .toDynamicValue(() => new DccFilterStore())
        .inSingletonScope()

    register<TSelectContainerStore>(DccTableFilterCurrencySelectContainerStoreSymbol)
        .toDynamicValue(
            () =>
                new SelectContainerStore({
                    options: getPortalCurrencies.filter(
                        (currency) => currency.value !== Currencies.ISK
                    ),
                    value: DEFAULT_CURRENCY
                })
        )
        .inSingletonScope()

    register<TRangePickerContainerStore>(DccTableFilterRangePickerContainerStoreSymbol)
        .toDynamicValue(() => new RangePickerStore({period: PeriodType.Month}))
        .inSingletonScope()

    register<IDccTableFilterStore>(DccTableFilterStoreSymbol)
        .toDynamicValue(
            (context: interfaces.Context) =>
                new DccTableFilterStore(
                    context.container.get(DccFilterStoreSymbol),
                    context.container.get(DccTableFilterRangePickerContainerStoreSymbol),
                    context.container.get(DccTableFilterCurrencySelectContainerStoreSymbol)
                )
        )
        .inSingletonScope()
}
